module.exports = __webpack_public_path__ + "img/Wp_2064.e93d7578.png";